<template>
  <div class="tab-text py-3">
    <ul class="vx-timeline">
      <div v-for="(item, i) in surat.disposisi" :key="i">
        <li>
          <div class="timeline-icon" :class="`bg-${item.color}`">
            <feather-icon
              :icon="item.icon"
              svgClasses="text-white stroke-current w-5 h-5"
            />
          </div>
          <div class="timeline-info">
            <p class="font-semibold">
              {{ item.pengguna ? item.pengguna.nama : "-" }}
            </p>
            <p class="text-grey text-sm">
              {{ item.pengguna ? item.pengguna.jabatan.nama : "-" }}
            </p>
            <p
              class="mt-2 activity-desc"
              v-html="`&quot;${item.keterangan}&quot;`"
            ></p>
          </div>
          <small class="text-grey activity-e-time">{{ item.created_at }}</small>
        </li>
        <li
          v-if="
            item.isOnDisposition &&
              item.isLastDisposition({
                length: surat.disposisi.length,
                index: i
              })
          "
        >
          <div class="timeline-icon bg-primary">
            <feather-icon
              icon="Edit3Icon"
              svgClasses="text-white stroke-current w-5 h-5"
            />
          </div>
          <div class="timeline-info">
            <p class="font-semibold">
              {{ item.tujuan_pengguna.nama }}
            </p>
            <p class="text-grey text-sm">
              {{ item.tujuan_pengguna.jabatan.nama }}
            </p>
            <p class="mt-2 activity-desc">
              "Sedang verifikasi surat ini"
            </p>
          </div>
          <small class="text-grey activity-e-time">{{ item.created_at }}</small>
        </li>
      </div>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    surat: {
      type: Object
    }
  }
};
</script>
